import { useEffect } from 'react'
import "./home.css";
import HomeBanner from '../homeBanner/homeBanner'
import SearchForm from '../../shared/components/searchForm/searchForm';
import { useDispatch, useSelector } from 'react-redux';
import { getFeaturedProducts } from '../../redux/actions';
import ProductsContainer from '../../shared/components/productsContainer/productsContainer';
import { useState } from 'react';
import { useHistory } from 'react-router';
const Home = () => {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const history = useHistory();


    useEffect(() => {
        window.scrollTo(0, 0);
        setLoading(true);
        const callback = () => {
            setLoading(false);
        }
        dispatch(getFeaturedProducts(callback));
    }, [dispatch])

    const categories = useSelector((state) => state.featuredProducts.categories);



    return (
        <div className="defaultHome">
            <HomeBanner />
            <SearchForm />
            <section className="product-listing-wrapper">
                <div className="container">
                    {categories && categories.map((category, index) => <ProductsContainer key={index} category={category} categoryIndex={index} loading={loading} />)}
                    <div className="d-flex justify-content-center mt-5">
                        <button className="btn btn-custom" style={{ height: "auto", width: 120 }} onClick={() => {
                            history.push("/search-result");
                        }
                        }>{"View More"}</button>
                    </div>

                </div>
            </section>
        </div>
    );
}

export default Home;